<script>
import attachmentService from '@/services/Attachments/attachmentService';
import pessoasService from '@/services/Pessoas/pessoasService';
import settingsService from '@/services/Settings/settingsService';
import VuePDFViewer from 'vue-instant-pdf-viewer';

import moment from 'moment';

import { Settings } from '@/firebase/index';

import { DoubleBounce } from 'vue-loading-spinner';

export default {
  name: 'terms-of-use',
  props: {
    financing: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    'vue-pdf-viewer': VuePDFViewer,
    DoubleBounce
  },
  data() {
    return {
      attachments: [],
      page: 1,
      numPages: 0,
      currentPage: 0,
      pageCount: 0,
      scale: 'page-width',
      attachmentsUrl: [],
      visible: false,
      isLoading: true,
      termsAccepted: false
    };
  },
  mounted() {
    this.getAttachments();
  },
  computed: {
    loggedPessoa() {
      return this.$store.getters.getPessoa;
    }
  },
  methods: {
    async getAttachments() {
      const attachments = await attachmentService.getTermsAttachments();
      const attachmentItems = await attachments.items;

      const { pessoa_id } = this.loggedPessoa;
      const pessoaFromFirebase = await pessoasService.getPessoa(pessoa_id);
      const pessoa = pessoaFromFirebase.data();
      
      const attachmentsArray = [];

      await attachmentItems.map(async item => {
        if ( item.name.toLowerCase() == 'Autodeclaração - Investidor Qualificado - Anexo 4-A'.toLowerCase() ) {
          if ( pessoa.dados_complementares.perfil && pessoa.dados_complementares.perfil.investimentos_financeiros > 1000000 ) {
            attachmentsArray.push({ item: item, url: await this.getURL(item.name), tipo: 'pdf' });
          }
        }
        else if ( item.name.toLowerCase() == 'Autodeclaração - Anexo 4-B'.toLowerCase() ) {
          if ( pessoa.dados_complementares.perfil && pessoa.dados_complementares.perfil.renda_bruta_anual > 100000 && pessoa.dados_complementares.perfil.investimentos_financeiros <= 1000000 ) {
            attachmentsArray.push({ item: item, url: await this.getURL(item.name), tipo: 'pdf' });
          }
        }
        else if ( item.name.toLowerCase() == 'Autodeclaração - Anexo 4-C'.toLowerCase() ) {
          if ( pessoa.dados_complementares.perfil && pessoa.dados_complementares.perfil.renda_bruta_anual < 100000 && pessoa.dados_complementares.perfil.investimentos_financeiros <= 1000000 ) {
            attachmentsArray.push({ item: item, url: await this.getURL(item.name), tipo: 'pdf' });
          }
        }
        else {
          attachmentsArray.push({ item: item, url: await this.getURL(item.name), tipo: 'pdf' });
        }
      });

      this.attachments = attachmentsArray;

      this.getTermosRisco(pessoa);

      this.isLoading = false;
    },
    async getTermosRisco(pessoa) {
      const settingsFromFirebase = await Settings.get();

      var settings = settingsFromFirebase.docs[0].data();
      settings.id = settingsFromFirebase.docs[0].id;

      // attachmentsArray.push({ item: item, url: await this.getURL(item.name), tipo: 'pdf' });

      const settings_termo4A = settings.termos_4a;
      const settings_termo4B = settings.termos_4b;
      const settings_termo4C = settings.termos_4c;

      const hoje = moment().format('DD/MM/YYYY');
      const razaoSocial = this.financing.dados_complementares.empresa.nome;
      
      const outrasPlataformas = pessoa.dados_complementares.perfil.investimentos_outras_plataformas ? pessoa.dados_complementares.perfil.investimentos_outras_plataformas : 0;
      const nestaPlataforma = pessoa.dados_complementares.perfil.investimentos_nesta_plataforma ? pessoa.dados_complementares.perfil.investimentos_nesta_plataforma : 0;
      
      const montantePreFormatado = parseFloat(outrasPlataformas + nestaPlataforma).toFixed(2).replace('.', ',');
      const montante = 'R$ ' + montantePreFormatado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');;
      
      var termo4A = settings_termo4A.replace('#data', hoje)
                                    .replace('#local', pessoa.endereco.cidade)
                                    .replace('#nomeInvestidor', pessoa.nome)
                                    .replace('#cpfInvestidor', pessoa.documento.numero);

      var termo4B = settings_termo4B.replace('#data', hoje)
                                    .replace('#local', pessoa.endereco.cidade)
                                    .replace('#nomeInvestidor', pessoa.nome)
                                    .replace('#cpfInvestidor', pessoa.documento.numero)
                                    .replace('#razaoSocialEmissor', razaoSocial)
                                    .replace('#montante', montante);

      var termo4C = settings_termo4C.replace('#data', hoje)
                                    .replace('#local', pessoa.endereco.cidade)
                                    .replace('#nomeInvestidor', pessoa.nome)
                                    .replace('#cpfInvestidor', pessoa.documento.numero)
                                    .replace('#razaoSocialEmissor', razaoSocial)
                                    .replace('#montante', montante);

      if ( pessoa.dados_complementares.perfil && pessoa.dados_complementares.perfil.investimentos_financeiros > 1000000 ) {
        this.attachments.push({ item: {content: termo4A, name: 'Autodeclaração - Anexo 4-A'}, url: '', tipo: 'editor', parseRef: 'parsedContentTermoAnexo' });
      }
      else if ( pessoa.dados_complementares.perfil && pessoa.dados_complementares.perfil.renda_bruta_anual > 100000 && pessoa.dados_complementares.perfil.investimentos_financeiros <= 1000000 ) {
        this.attachments.push({ item: {content: termo4B, name: 'Autodeclaração - Anexo 4-B'}, url: '', tipo: 'editor', parseRef: 'parsedContentTermoAnexo' });
      }
      else if ( pessoa.dados_complementares.perfil && pessoa.dados_complementares.perfil.renda_bruta_anual <= 100000 && pessoa.dados_complementares.perfil.investimentos_financeiros <= 1000000 ) {
        this.attachments.push({ item: {content: termo4C, name: 'Autodeclaração - Anexo 4-C'}, url: '', tipo: 'editor', parseRef: 'parsedContentTermoAnexo' });
      }

      /**
       * Contratos
       */
      const publicSettings = await settingsService.getPublicSettings();
      
      if ( publicSettings.terms ) {
        
        var contratoOfertaToReplace = '';
        if ( this.financing.possui_contrato_personalizado ) {
          contratoOfertaToReplace = this.financing.contrato_personalizado;
        }
        else if ( publicSettings.terms.contrato_padrao ) {
          contratoOfertaToReplace = publicSettings.terms.contrato_padrao;
        }

        const contratoOferta = contratoOfertaToReplace.replace('#data', hoje)
                                    .replace('#local', pessoa.endereco.cidade)
                                    .replace('#nomeInvestidor', pessoa.nome)
                                    .replace('#cpfInvestidor', pessoa.documento.numero)
                                    .replace('#razaoSocialEmissor', razaoSocial)
                                    .replace('#montante', montante);
        this.attachments.push({ item: {content: contratoOferta, name: 'Contrato da Oferta'}, url: '', tipo: 'editor', parseRef: 'parsedContentContratoOferta' });

        if ( publicSettings.terms.termo_ciencia_risco ) {
          const termoCienciaRisco = publicSettings.terms.termo_ciencia_risco.replace('#data', hoje)
                                    .replace('#local', pessoa.endereco.cidade)
                                    .replace('#nomeInvestidor', pessoa.nome)
                                    .replace('#cpfInvestidor', pessoa.documento.numero)
                                    .replace('#razaoSocialEmissor', razaoSocial)
                                    .replace('#montante', montante);
          this.attachments.push({ item: {content: termoCienciaRisco, name: 'Termo de Ciência de Risco'}, url: '', tipo: 'editor', parseRef: 'parsedContentTermoCienciaRisco' });
        }
      }
    },
    nextStep() {
      this.$emit('nextStep');
    },
    async getURL(name) {
      const url = await attachmentService.urlAttachment(
        name,
        'InvestmentTerms'
      );

      return url;
    }
  }
};
</script>

<template>
  <div class="terms-of-use">
    <h4>Termos de Uso e Termo de adesão e ciência de risco</h4>
    <p>
      Para dar continuidade ao processo, você deve aceitar os seguintes termos:
    </p>

    <div class="loading-spinner">
      <double-bounce v-if="isLoading"></double-bounce>
    </div>

    <div class="attachment-list">
      <div
        class="attachment-item"
        v-for="(attachment, index) in attachments"
        :key="index"
        v-b-toggle="`accordion-${index}`"
      >
        <h5>
          {{ attachment.item.name }}
          <span>
            <i class="fas fa-angle-down"></i>
          </span>
        </h5>

        <b-collapse
          :id="`accordion-${index}`"
          :visible="visible"
          accordion="my-accordion"
          role="tabpanel"
        >
          <vue-pdf-viewer
            v-if="attachment.tipo == 'pdf'"
            width="100%"
            height="500px"
            :url="attachment.url"
          ></vue-pdf-viewer>
          <div style="border: 1px solid #555; padding: 5px; overflow-y: auto; height: 400px;">
            <div v-if="financing.content" class="ql-container ql-snow" style="border: 0px !important;">
              <div class="ql-editor">
                <div v-if="attachment.tipo == 'editor'" v-html="attachment.item.content"></div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>

    <form @submit.prevent="nextStep()">
      <div class="terms-accepted">
        <input type="checkbox" required v-model="termsAccepted" />
        <label for=""
          >Declaro que li e estou de acordo com todos os termos acima</label
        >
      </div>

      <div class="terms-button">
        <button
          :class="{ 'is-disabled': !termsAccepted }"
          class="button"
          type="submit"
        >
          Prosseguir
        </button>
      </div>
    </form>
  </div>
</template>
